// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--LhSmA","title":"styles-module--title--1hL05"};